<template>
	<div class="contact-wrap">
		<!-- 联系我们 -->
		<div class="ways">
			<h1 class="title">{{$t('contact.contact')}}</h1>
			<div class="content">
				<div class="ways-1">
					<div class="way-img-1">
						<i class="iconfuwurexian iconfont"></i>
					</div>
					<div>
						<label>{{$t('contact.addBJ')}}</label>
						<span>+86 0512-67990267</span>
					</div>
				</div>
				<div class="ways-2">
					<div class="way-img-2">
						<i class="iconhuanyingzhixin iconfont"></i>
					</div>
					<div>
						<label>{{$t('contact.welcome')}}</label>
						<span>bd@meta-clinical.com</span>
					</div>
				</div>
			</div>
		</div>
		<!-- 区域办公室 -->
		<KllkMap></KllkMap>
		<!-- 合作表单 -->
		<KllkForm></KllkForm>
	</div>
</template>
<script>
// 组件
import KllkForm from "../../components/kllk-form-warp";
import KllkMap from "../contact/components/map";

export default {
	components: {
		KllkForm,
		KllkMap,
	}
};
</script>
<style lang="less" scoped>
@import "../../style/constant";

.contact-wrap {
	background-color: #ffffff;
	.ways {
		width: @page-width;
		margin: 120px auto 140px;

		.title {
			text-align: center;
			margin-bottom: 60px;
		}
	}

	.ways {
		.content {
			display: flex;
			width: 100%;
			justify-content: space-between;

			.ways-1,
			.ways-2 {
				width: 48%;
				height: 165px;
				display: flex;
				align-items: center;
				justify-content: space-around;
				box-shadow: 0px 0px 40px rgba(42, 105, 239, 0.16);
            }
            
            @media screen and (max-width: 996px) {
                .ways-1,
			    .ways-2 {
                    width: 95%;
                    margin-bottom: 20px;
                }
            }

			.way-img-1,
			.way-img-2 {
				.iconfont {
					color: @primary-color;
					font-size: 70px;
				}
			}

			label,
			span {
				display: block;
				text-align: left;
			}

			label {
				opacity: 0.5;
				font-size: 16px;
				color: @h1-color;
				width: 100%;
				margin-bottom: 10px;
			}

			span {
				font-size: 28px;
				color: @h1-color;
				display: block;
				cursor: pointer;
				word-break: break-all;
			}
			@media screen and (max-width: 996px) {
				span {
					font-size: 21px;
				}
			}
		}
	}
	@media screen and (max-width: 996px) {
		.ways {
            width: 100%;
            margin: 60px 0;
            .title {
                margin-bottom: 30px;
            }
			.content {
                flex-direction: column;
                align-items: center;
			}
		}
	}
}
</style>
